import { useState } from "react";

import { useUserNotificationsService } from "shared/components/organisms/AppNotification/hooks/useUserNotificationsService";
import { useTopbarContext } from "shared/providers/Layout/hooks/useTopbarContext";

import { captureException, captureMessage } from "@sentry/nextjs";

export const useUserNotificationsPaginationService = () => {
  const {
    addNotificationsToList,
    addNewNotificationsToList,
    hasNewNotifications,
    alreadyLoadedNewNotifications, setAlreadyLoadedNewNotifications
  } = useTopbarContext();
  const {
    getNotifications,
    paginationInfo,
    isNotificationsLoading,
    getNewNotifications,
  } = useUserNotificationsService();

  const loadPaginatedNotifications = async (): Promise<boolean> => {
    const shouldGetOnlyNewNotifications =
      hasNewNotifications && !alreadyLoadedNewNotifications;

    if (paginationInfo?.isLastPage && !shouldGetOnlyNewNotifications)
      return true;

    try {
      const result = shouldGetOnlyNewNotifications
        ? await getNewNotifications()
        : await getNotifications();

      if (shouldGetOnlyNewNotifications) {
        addNewNotificationsToList(result);
        setAlreadyLoadedNewNotifications(true);
      } else {
        addNotificationsToList(result);
      }

      return true;
    } catch (error) {
      console.log("Error (loadPaginatedNotifications): ", error);
      captureMessage("Error (loadPaginatedNotifications)");
      captureException(error);

      return false;
    }
  };

  return {
    loadPaginatedNotifications,
    paginationInfo,
    isNotificationsLoading,
  };
};
